var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckWithEllipse = function SvgIconCheckWithEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.51 4.448a18.3 18.3 0 0 0-4.099-1.037C14.421 2.08 5.244 9.1 3.912 19.09 2.58 29.079 9.6 38.257 19.59 39.589c9.99 1.331 19.168-5.688 20.5-15.678.187-1.4.21-2.783.083-4.132",
    stroke: "#B37AFC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.092 6.323 22.314 25.332l-5.793-5.703",
    stroke: "#B37AFC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconCheckWithEllipse;